/** Display formatters shared by the live student panel and review. */

export function formatMinutesSeconds(ms: number): string {
  const totalSeconds = Math.floor(Math.max(0, ms) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}m ${seconds}s`;
}

export const EASTERN_TIME_ZONE = "America/New_York";

export function formatShortDateTime(value: string | null | undefined): string {
  if (!value) return "Not available";
  return new Date(value).toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: EASTERN_TIME_ZONE,
  });
}

export function formatTimeOnly(value: string): string {
  return new Date(value).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    timeZone: EASTERN_TIME_ZONE,
  });
}

export function formatCount(value: number): string {
  return value.toLocaleString();
}
